/**
 * Le preferenze salvate nel browser quando il prodotto si chiamava ADABS.
 *
 * Tema, lingua, sezioni chiuse, cruscotto, e soprattutto il token di sessione
 * stavano sotto chiavi `adabs.*`. Rinominarle senza portarle con sé avrebbe
 * disconnesso tutti e fatto perdere a ciascuno le proprie preferenze al primo
 * caricamento dopo l'aggiornamento. Qui si copiano una volta in `censo.*` (se
 * la nuova non c'è già) e si tolgono le vecchie.
 *
 * Importato per primo da `main.tsx`: deve girare prima che chiunque legga.
 */
function migra(archivio: Storage) {
  const vecchie: string[] = []
  for (let i = 0; i < archivio.length; i++) {
    const chiave = archivio.key(i)
    if (chiave && chiave.startsWith('adabs.')) vecchie.push(chiave)
  }
  for (const chiave of vecchie) {
    const nuova = 'censo.' + chiave.slice('adabs.'.length)
    const valore = archivio.getItem(chiave)
    if (valore !== null && archivio.getItem(nuova) === null) archivio.setItem(nuova, valore)
    archivio.removeItem(chiave)
  }
}

try {
  migra(localStorage)
  migra(sessionStorage)
} catch {
  // Archivio non disponibile (navigazione privata, quote): niente da migrare.
}

export {}
